export const useAppearancePlugin = () => {
  const addAppearancePlugin = () => {
    const pluginScript = document.createElement('script')
    pluginScript.setAttribute('src', process.env.VUE_APP_API_HOST+'?v=28')
    pluginScript.setAttribute('charset', 'UTF-8')
    pluginScript.setAttribute('id', 'ssbee-plugin')
    document.body.appendChild(pluginScript)
  }

  return {
    addAppearancePlugin
  }
}